<template>
    <frontend-layout :hide-header="true" :hide-footer="true">
        <div class="flex flex-col lg:h-screen lg:flex-row">
            <div class="h-full bg-white p-4 pb-16 lg:w-1/2 lg:p-16">
                <div class="" v-if="$page.props.login_signup_enabled">
                    <div
                        class="mx-auto flex h-full flex-col lg:ml-auto lg:mr-0 lg:max-w-lg"
                    >
                        <div class="mb-16 h-12">
                            <Link :href="route('frontend.home')">
                                <img
                                    class="h-12"
                                    src="/assets/art/logos/emtprep_logo_color@2x.png"
                                />
                            </Link>
                        </div>

                        <div
                            class="mb-8 flex justify-between gap-4 border-b border-gray-200"
                        >
                            <div
                                @click="step = 'select_level'"
                                :class="
                                    'border-b-4 pb-2 hover:cursor-pointer' +
                                    ' ' +
                                    (step === 'select_level'
                                        ? 'border-secondary-500'
                                        : 'border-transparent')
                                "
                            >
                                Select&nbsp;Level
                            </div>
                            <div
                                @click="step = 'create_account'"
                                :class="
                                    'border-b-4 pb-2 hover:cursor-pointer' +
                                    ' ' +
                                    (step === 'create_account'
                                        ? 'border-secondary-500'
                                        : 'border-transparent hover:text-primary-500')
                                "
                            >
                                Create&nbsp;Account
                            </div>
                            <div class="border-b-4 border-transparent pb-2">
                                Billing&nbsp;Details
                            </div>
                        </div>

                        <div
                            v-if="step === 'select_level'"
                            class="flex flex-grow flex-col lg:max-h-[700px]"
                        >
                            <div class="">
                                <div class="mb-4 text-[22px] font-semibold">
                                    Select your level
                                </div>
                            </div>
                            <div class="leading-7">
                                Please select the level of the exam that you’re
                                studying for.
                            </div>
                            <div class="mt-8">
                                <form-radio
                                    :options="providerLevelOptions"
                                    v-model="form.provider_level"
                                    css-classes="w-[20px] h-[20px] top-1 relative mr-2 opacity-20 checked:opacity-100"
                                />
                            </div>
                            <div class="mt-auto flex justify-end">
                                <span
                                    class="btn btn-primary"
                                    @click="step = 'create_account'"
                                >Continue</span
                                >
                            </div>
                        </div>

                        <form
                            v-if="step === 'create_account'"
                            @submit.prevent="submit"
                            class="flex h-full flex-col gap-4 lg:max-h-[700px]"
                        >
                            <div class="flex gap-8">
                                <div class="w-1/2">
                                    <form-input
                                        label="First name"
                                        name="first_name"
                                        v-model="form.first_name"
                                    />
                                </div>
                                <div class="w-1/2">
                                    <form-input
                                        label="Last name"
                                        name="last_name"
                                        v-model="form.last_name"
                                    />
                                </div>
                            </div>
                            <div class="">
                                <form-input
                                    label="Email"
                                    name="email"
                                    v-model="form.email"
                                />
                            </div>
                            <div class="">
                                <form-input
                                    label="Confirm email address"
                                    name="email_confirmation"
                                    v-model="form.email_confirmation"
                                />
                            </div>
                            <div class="">
                                <form-input
                                    label="Password"
                                    name="password"
                                    type="password"
                                    v-model="form.password"
                                    hint="Password must be at least 8 characters"
                                />
                            </div>
                            <div class="">
                                <form-input
                                    label="Confirm password"
                                    name="password_confirmation"
                                    type="password"
                                    v-model="form.password_confirmation"
                                />
                            </div>
                            <div class="">
                                <form-checkbox
                                    v-model="form.agreed_to_terms"
                                    name="agreed_to_terms"
                                >
                                    <div class="text-[15px] leading-7">
                                        I have read and agree to the EMTprep
                                        <Link
                                            class="link"
                                            href="/legal/terms-and-conditions"
                                        >Terms and Conditions
                                        </Link>
                                        and
                                        <Link
                                            class="link"
                                            href="/legal/membership-agreements"
                                        >Membership Agreement
                                        </Link>
                                    </div>
                                </form-checkbox>
                            </div>
                            <div class="">
                                <form-checkbox
                                    v-model="form.marketing_opt_in"
                                    name="marketing_opt_in"
                                >
                                    <div class="text-[15px] leading-7">
                                        I would like to receive EMS updates,
                                        related news, and offers from Classward,
                                        LLC.
                                        <div class="font-xs text-gray-500">
                                            Limited emails and we do not sell
                                            your information.
                                        </div>
                                    </div>
                                </form-checkbox>
                            </div>
                            <div class="mt-12 mt-auto flex justify-end">
                                <button class="btn btn-primary">
                                    Continue to Payment
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
                <div class="" v-else>
                    Signup is currently disabled, please try again later.
                </div>
            </div>

            <!-- // cart-->
            <div class="h-full bg-gray-50 p-4 lg:w-1/2 lg:p-16">
                <div class="mx-auto lg:ml-0 lg:mr-auto lg:max-w-lg">
                    <div class="lg:mb-16 lg:h-12"></div>
                    <StudentCheckoutCart
                        :plan="plan"
                        :total="plan.price_usd"
                        :subtotal="plan.price_usd"
                        :promo-code="null"
                        v-on:promo-applied="updatePromoCode"
                    />
                </div>
            </div>
        </div>
    </frontend-layout>
</template>

<script>
import FrontendLayout from "@/_Layouts/FrontendLayout";
import FormInput from "@/Components/FormInput";
import FormCheckbox from "@/Components/FormCheckbox";
import FormRadio from "@/Components/FormRadio";
import StudentCheckoutCart from "@/Components/StudentCheckoutCart";

export default {
    name: "StudentRegisterCreateAccountForm",
    components: {
        StudentCheckoutCart,
        FormRadio,
        FormCheckbox,
        FrontendLayout,
        FormInput,
    },
    props: {
        plans: {},
        providerLevelOptions: {
            type: Array,
            default: [],
        },
    },
    data() {
        return {
            plan: this.plans[route().params.plan ?? "monthly"],
            step: "select_level",
            form: this.$inertia.form({
                plan_id: this.plans[route().params.plan ?? "monthly"].id,
                provider_level: 2,
                first_name: "",
                last_name: "",
                email: "",
                email_confirmation: "",
                password: "",
                password_confirmation: "",
                agreed_to_terms: false,
                promo_code: null,
            }),
        };
    },
    methods: {
        submit() {

            this.$inertia.post(
                route("frontend.student.submit-register-create-account-form"),
                this.form
            );
        },
        updatePromoCode(value) {
            this.form.promo_code = value;
        },
    },
};
</script>
